import { Dispatch } from 'redux';
import { apiErrorClear } from '../../../../../global/ducks/base-api';
import { addUnpaidLeaveWithHandler, getEmployment } from '../../../../../global/ducks/benadmin-api';
import { getFormattedDate } from '../../../../../global/helpers/date-helpers';
import { dispatchSetEmployment, dispatchSetEmploymentFailed } from '../employment-slice';
import { AddUnpaidLeaveFormModel } from './add-unpaid-leave-form-models';

export const addUnpaidLeave = (
	dispatch: Dispatch<any>,
	employeeId: string | number,
	savedValues: AddUnpaidLeaveFormModel,
) => {

	dispatch(apiErrorClear());

	const payload = {
		unpaid_leave: {
			start_date: getFormattedDate(savedValues.start_date),
		},
	};


	const postSuccess = () => {

		dispatch(getEmployment(employeeId, savedValues.employment_id, dispatchSetEmployment(dispatch), () => dispatchSetEmploymentFailed(dispatch)));
	};

	dispatch(addUnpaidLeaveWithHandler(employeeId, savedValues.employment_id, payload, () => postSuccess()));
};